
















import { Component, Vue, Prop, Watch } from "@/common";
import ElementUI from "element-ui";

@Component
export default class SelectTree extends Vue {
  @Prop()
  selectValue!: number;

  @Prop({default:true})
  clearable!: boolean;

  nodes = {
    value: "id", // ID字段名
    label: "title", // 显示名称
    children: "children" // 子级字段名
  };

  @Prop()
  options!: any[];

  valueId = this.selectValue;
  valueTitle = "";
  defaultExpandedKey=[];

  get selectTree(): ElementUI.Tree {
    return this.$refs["selectTree"] as ElementUI.Tree;
  }
  mounted() {
    this.initHandle();
  }
  // 初始化值
  initHandle() {
    if (this.valueId) {
      this.valueTitle = this.selectTree.getNode(this.valueId).data["title"]; // 初始化显示
      this.selectTree.setCurrentKey(this.valueId); // 设置默认选中
      this.defaultExpandedKey.push(this.valueId); // 设置默认展开
    }
  }
  // 切换选项
  handleNodeClick(node) {
    this.valueTitle = node[this.nodes.label];
    this.valueId = node[this.nodes.value];
    this.$emit("getValue", this.valueId);
    this.defaultExpandedKey = [];
  }
  // 清除选中
  clearHandle() {
    this.valueTitle = "";
    this.valueId = null;
    this.defaultExpandedKey = [];
    this.selectTree.setCurrentKey(null); // 设置默认选中
    this.$emit("getValue", null);
  }
}
